
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { IntegrationPageRoutingModule } from './integration-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { IntegrationBridgeComponent } from './integration-bridge/integration-bridge.component';
import { IntegrationCreateComponent } from './integration-create/integration-create.component';
import { NgJsonEditorModule } from 'ang-jsoneditor'
import { IntegrationUpdateComponent } from './integration-update/integration-update.component';
import { IntegrationDetailsComponent } from './integration-details/integration-details.component';
import { OperationsPipe } from '../core/pipes/operations.pipe';
import { RemoveSpecialCharactersFromStringPipe } from '../core/pipes/remove-special-characters-from-string.pipe';
import { MonacoEditorModule } from '@materia-ui/ngx-monaco-editor';
import { MatDialogModule } from '@angular/material/dialog';
import { CKEditorModule } from 'ckeditor4-angular';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
import { LiveStreamLogsComponent } from './live-stream-logs/live-stream-logs.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { AutocompletePositionDirective } from './auto-complete-position.directive';
// import { NgxCopyToClipboardModule } from 'ngx-copy-to-clipboard';
// import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import {MatTabsModule} from '@angular/material/tabs';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    IntegrationPageRoutingModule,
    IonicModule,
    NgJsonEditorModule,MatTabsModule,
    ReactiveFormsModule,
    MonacoEditorModule,
    // MonacoEditorModule.forRoot(),
    MatDialogModule,
    CKEditorModule,
    CodemirrorModule,
    ScrollingModule,
  ],
  declarations: [
    IntegrationBridgeComponent,
    IntegrationCreateComponent,
    IntegrationUpdateComponent,
    IntegrationDetailsComponent,
    LiveStreamLogsComponent,
    OperationsPipe,
    RemoveSpecialCharactersFromStringPipe,
    AutocompletePositionDirective
  ]
})
export class IntegrationPageModule { }
